/**
 * Redirection configuration form — the interactive bits of the "card per country" layout.
 *
 * Per country:
 *   - the depot list is shown only for the "selected depots only" option, so the other two options
 *     collapse it and keep the form compact
 *   - the distance inputs dim when redirection is disabled
 *   - "select all" / "clear" tick or untick every depot at once (28 depots for CZ)
 *   - the header badge follows the selected mode (text and colour) and, together with the "n/m"
 *     counter, follows the checkboxes live
 *
 * Everything here is cosmetic. The server decides by the radio value alone: hidden checkboxes are
 * still submitted and are ignored unless "selected depots only" is chosen. The distance inputs are
 * deliberately dimmed rather than disabled — disabled inputs are not submitted, and the server
 * validates them whenever the country does not disable redirection.
 *
 * The value that reveals the list comes from the markup (data-depot-list-shown-for) and the badge
 * labels and classes come from the form's data-depot-status-config, so the DepotSelectionMode enum
 * and the translations stay the single source of truth — nothing mode- or language-specific is
 * hardcoded here. Labels arrive with {selected}/{total} placeholders for the live counts.
 */
(function () {
    const DIM_CLASS = 'opacity-50';

    function init() {
        const form = document.querySelector('[data-form="redirection-configuration"]');
        if (!form) {
            return;
        }

        const statusConfigRaw = form.getAttribute('data-depot-status-config');
        const statusConfig = statusConfigRaw ? JSON.parse(statusConfigRaw) : null;

        form.querySelectorAll('[data-depot-selection]').forEach(function (group) {
            const country = group.getAttribute('data-depot-selection');
            const list = form.querySelector('[data-depot-list="' + country + '"]');
            if (!list) {
                return;
            }

            const shownFor = list.getAttribute('data-depot-list-shown-for');
            const radios = group.querySelectorAll('input[type="radio"]');
            const checkboxes = list.querySelectorAll('input[type="checkbox"]');
            const distanceCell = form.querySelector('[data-distance-cell="' + country + '"]');
            const status = form.querySelector('[data-depot-status="' + country + '"]');
            const counter = form.querySelector('[data-depot-count="' + country + '"]');

            function selectedMode() {
                const selected = Array.from(radios).find(function (radio) {
                    return radio.checked;
                });

                return selected ? selected.value : null;
            }

            function countChecked() {
                return Array.from(checkboxes).filter(function (checkbox) {
                    return checkbox.checked;
                }).length;
            }

            function syncCounts() {
                if (counter) {
                    counter.textContent = countChecked() + '/' + checkboxes.length;
                }

                syncBadge();
            }

            function syncBadge() {
                if (!status || !statusConfig) {
                    return;
                }

                const entry = statusConfig[selectedMode()];
                if (!entry) {
                    return;
                }

                Object.keys(statusConfig).forEach(function (mode) {
                    status.classList.remove(statusConfig[mode].badgeClass);
                });
                status.classList.add(entry.badgeClass);

                status.textContent = entry.label
                    .replace(/\{selected\}/g, countChecked())
                    .replace(/\{total\}/g, checkboxes.length);
            }

            function sync() {
                const mode = selectedMode();

                list.hidden = mode !== shownFor;

                if (distanceCell) {
                    const dimFor = distanceCell.getAttribute('data-distance-dim-for');
                    distanceCell.classList.toggle(DIM_CLASS, mode === dimFor);
                }

                syncCounts();
            }

            radios.forEach(function (radio) {
                radio.addEventListener('change', sync);
            });

            checkboxes.forEach(function (checkbox) {
                checkbox.addEventListener('change', syncCounts);
            });

            bindBulk(form, country, 'data-depot-select-all', checkboxes, true, syncCounts);
            bindBulk(form, country, 'data-depot-clear', checkboxes, false, syncCounts);

            sync();
        });
    }

    function bindBulk(form, country, attribute, checkboxes, checked, onDone) {
        const link = form.querySelector('[' + attribute + '="' + country + '"]');
        if (!link) {
            return;
        }

        link.addEventListener('click', function (event) {
            event.preventDefault();

            checkboxes.forEach(function (checkbox) {
                checkbox.checked = checked;
            });

            onDone();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
